const SET_STATUS = 'status/SET_STATUS';
const SET_INCREASE_NUMBER_OF_FAILURES =
  'status/SET_INCREASE_NUMBER_OF_FAILURES';
const SET_RESET_NUMBER_OF_FAILURES = 'status/SET_RESET_NUMBER_OF_FAILURES';

export default {
  SET_STATUS,
  SET_RESET_NUMBER_OF_FAILURES,
  SET_INCREASE_NUMBER_OF_FAILURES,
};
